export default function ChatSerializer(data){
    if(data)
    return {
        id: data.id,
        threadName: data.name,
        user: data.user_id,
        menu: data.menu_id,
        insertDate: data.creation_date,
    }
    return null
}